'use strict';
'use es6';

/**
 * Detect if a mouseevent occurred within a given rectangle of UI coordinates
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isCursorOver = exports.isCursorOver = function isCursorOver(boundingClientRect, mouseEvent) {
  var top = boundingClientRect.top,
      bottom = boundingClientRect.bottom,
      left = boundingClientRect.left,
      right = boundingClientRect.right;
  var X = mouseEvent.clientX,
      Y = mouseEvent.clientY;


  return X >= left && X <= right && Y <= bottom && Y >= top;
};

/**
 * Does `rect1` overlap `rect2`?
 *
 * Note that overlaps of less than 1px are ignored, to prevent Tethers that are visually flush from
 * being considered "overlapping" when Tether adjusts them to align with display pixels.
 *
 * @param {Object} rect1
 * @param {Object} rect2
 * @returns {boolean}
 **/
var isOverlapping = exports.isOverlapping = function isOverlapping(rect1, rect2) {
  return rect1.top + 1 < rect2.bottom && rect2.top + 1 < rect1.bottom && rect1.left + 1 < rect2.right && rect2.left + 1 < rect1.right;
};

/**
 * Return the rectangular coordinates of the max area containing both elements
 *
 * @returns Object {top: Number, bottom: Number, left: Number, right: Number}
 **/
var calculateSurroundingRect = function calculateSurroundingRect(target, tooltip) {
  return {
    top: Math.min(tooltip.top, target.top),
    bottom: Math.max(tooltip.bottom, target.bottom),
    left: Math.min(tooltip.left, target.left),
    right: Math.max(tooltip.right, target.right)
  };
};

/**
 * Determine if a tooltip should close, given the target coords, tooltip coords,
 * placement config of the tooltip, and the originating mouse event
 **/
var shouldTooltipClose = exports.shouldTooltipClose = function shouldTooltipClose(target, tooltip, mouseEvent) {
  return !isCursorOver(calculateSurroundingRect(target, tooltip), mouseEvent);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/tooltip/utils/Hover.js
// module id = 265
// module chunks = 3 4 5